export enum EnumTiposDatosPegado {
  String = 1,
  Number = 2,
  Currency = 3,
  Quantity = 4,
  Boolean = 5,
  Url = 6,
  Mail = 7
}
